import { useField } from "formik";
import { useEffect, useRef } from "react";

import { FileUpload, FileUploadProps } from "./FileUpload";
import { FileInfo, fileToFileInfo, readFileAsURL } from "./utils";

interface Props extends Omit<FileUploadProps, "onSelected"> {
  name: string;
}

/**
 * @deprecated use FileUploadFormikField instead
 */
export function FileUploadField(props: Props) {
  const { name, ...fileUploadProps } = props;

  const [field, meta, helpers] = useField(name);

  const files = useRef<FileInfo[]>(field.value || []);

  const handleFileSelected = async (file: File) => {
    helpers.setTouched(true);
    const content = await readFileAsURL(file);

    // useRef is being used here otherwise when you upload multiple files at the same time files gets out of sync
    files.current = [...files.current, fileToFileInfo(file, content)];
    helpers.setValue(files.current);
  };

  useEffect(() => {
    files.current = field.value;
  }, [field.value]);

  return (
    <FileUpload
      error={meta.touched && meta.error}
      {...fileUploadProps}
      onSelected={handleFileSelected}
      files={field.value || []}
      onRemove={(fileToRemove) => {
        const currFiles: FileInfo[] = field.value || [];
        helpers.setValue(currFiles.filter((file) => file !== fileToRemove));
      }}
    />
  );
}
